<template>
  <Error v-if="apiConnectionError || maintenanceMode" />
  <router-view v-else-if="isEmbedRoute" />
  <template v-else>
    <TopNavigation v-if="$auth.isAuthenticated.value" />
    <router-view :key="currentRoute.name" class="pl-3 pr-3 pt-28" />
    <Footer v-if="$auth.isAuthenticated.value" />
    <SessionTimeoutModal
      v-if="showSessionTimeoutModal"
      @close-modal="methods.closeSessionModal"
    />
  </template>
  <FeatureFlagFlipper v-if="canToggleFeatures" />
</template>

<script lang="ts">
import { defineComponent, computed, ref, inject, onMounted } from 'vue';

import TopNavigation from '@/components/sections/TopNavigation.vue';
import Footer from '@/components/sections/Footer.vue';
import SessionTimeoutModal from '@/components/sections/SessionTimeoutModal.vue';
import { useStore } from '@/store';
import { authState } from '@/services/integrations/auth0';
import SessionTimeoutTimer from '@/services/session-timeout-timer';
import { getters as generalGetters } from '@/store/modules/general/getters';
import { GeneralActionTypes } from './store/modules/general/action-types';
import router from './router';
import FeatureFlagFlipper from './components/sections/FeatureFlagFlipper.vue';
import { canToggleFeatures } from './plugins/permissions';
import Error from './views/Error.vue';
import { FeatureFlag, getFeatureFlag } from './services/config';
import { LeadsActionTypes } from '@/store/modules/leads/actions';
import { TaskViewActionTypes } from './store/modules/taskView/action-types';

export default defineComponent({
  name: 'App',
  components: {
    TopNavigation,
    Footer,
    SessionTimeoutModal,
    FeatureFlagFlipper,
    Error,
  },
  setup() {
    const store = useStore();
    let sessionTimeoutTimer: SessionTimeoutTimer;
    const currentRoute = ref(router.currentRoute);
    const apiConnectionError = inject('apiConnectionError');
    const maintenanceMode = getFeatureFlag(FeatureFlag.MAINTENANCE_MODE)
      .enabled;

    if (authState.isAuthenticated.value) {
      sessionTimeoutTimer = new SessionTimeoutTimer();
      store.dispatch(
        GeneralActionTypes.GET_CLIENT_NAME_RESOLUTION_MAP,
        undefined
      );
    }

    const showSessionTimeoutModal = computed(() => {
      return generalGetters.getShowSessionTimeoutModalState(
        store.state.general
      );
    });

    const closeSessionModal = () => {
      store.dispatch(GeneralActionTypes.SET_SHOW_SESSION_MODAL, false);
      sessionTimeoutTimer.start();
    };

    const isEmbedRoute = computed(() => {
      return (
        currentRoute.value.name && currentRoute.value.matched[0].meta.embed
      );
    });

    const getNotifications = () => {
      if (authState.isAuthenticated.value) {
        store.dispatch(LeadsActionTypes.GET_NEW_LEADS_COUNT, undefined);
        store.dispatch(TaskViewActionTypes.GET_NEW_TASKS_COUNT, undefined);
        store.dispatch(TaskViewActionTypes.GET_NEW_TASKS_ALL_COUNT, undefined);
      }
    };

    onMounted(() => {
      getNotifications();
    });

    return {
      showSessionTimeoutModal,
      currentRoute,
      canToggleFeatures,
      methods: { closeSessionModal },
      apiConnectionError,
      maintenanceMode,
      isEmbedRoute,
    };
  },
});
</script>
